import { createBrowserRouter } from "react-router";

import { ROUTES } from "./routes";

export const router = createBrowserRouter(ROUTES);
